// ═══════════════════════════════════════════════════════════
// firebase/config.js
// SOURCE UNIQUE FIREBASE POUR TOUTE L'APPLICATION
// Projet : pour100johnny-app
// ═══════════════════════════════════════════════════════════

import {
  initializeApp,
  getApps,
  getApp
} from 'firebase/app'

import {
  getAuth
} from 'firebase/auth'

import {
  getFirestore
} from 'firebase/firestore'

import {
  getStorage
} from 'firebase/storage'

// ============================================================
// CONFIGURATION DU NOUVEAU PROJET FIREBASE
// ============================================================

const firebaseConfig = {
  apiKey: 'AIzaSyACjiP6_BG1nF8WqtIY3iBeprcCNNnKR2o',
  authDomain: 'pour100johnny-app.firebaseapp.com',
  projectId: 'pour100johnny-app',
  storageBucket: 'pour100johnny-app.firebasestorage.app',
  messagingSenderId: '632505953884',
  appId: '1:632505953884:web:179529e6055c3cd2188099',
  measurementId: 'G-MQS6MTDPM5'
}

// ============================================================
// INITIALISATION UNIQUE
// ============================================================

const app =
  getApps().length === 0
    ? initializeApp(firebaseConfig)
    : getApp()

// ============================================================
// SERVICES FIREBASE
// ============================================================

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

export default app